'use client'

import Article from '@/entities/blog-page/Article'

export const BlogItemPage = ({ blogData }) => {
    return (
        <div className={'BlogItemPage'}>
            <Article article={blogData} />
            {/*<GoodsSlider/>*/}
        </div>
    )
}
